import React, {Component} from 'react';
import userImage from '../../assets/128x128.jpg';
import * as ChatActions from '../../store/actions/chatActions';
import api from '../../utils/api';
import moment from 'moment';
import $ from 'jquery';
import {emojify} from 'react-emojione';
import 'emojione-picker/css/picker.css';
import EmojiPicker from 'emojione-picker';
import Linkify from 'linkifyjs/react';
import {NotificationManager} from 'react-notifications';
import jwt from 'jsonwebtoken';


// Components
import ChatSidebar from './ChatSidebar';
import ThreadView from './ThreadView';
import TicketView from './TicketView';

// Instructor Components
import InstructorChatSidebar from './InstructorChatSidebar';
import InstructorTicketView from './InstructorTicketView';

// Admin Components
import AdminChatSidebar from './AdminChatSidebar';
import AdminAnnouncementsView from './AdminAnnouncementsView';
import AdminAttachmentsView from './AdminAttachmentsView';
import AdminChatSettingsView from './AdminChatSettingsView';
import AdminFlaggedCommentsView from './AdminFlaggedCommentsView';
import AdminInstructorView from './AdminInstructorView';
import AdminTicketView from './AdminTicketView';


class Chat extends Component {
    
    
    constructor(props){
        super(props);
        this.state = {
            socket: null,
            currentThread: null,
            currentMessageThread: {},
            content: '',
            sidebarOpened: false,
            loading: false,
            online: true,
            changingStatus: false,
            activeAttachmentView: 'Pictures',
            searchFiles: '',
            galleryActive: false,
            galleryIndex: 0,
            userSearch: ''
        }
    }
    
  
    
    
    nl2br = (str, is_xhtml) => {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br />';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
    
    determineThread = () => {
        if(this.props.match.params.threadId){
            if(this.props.match.params.threadId !== this.state.currentThread){
                let thread = {};
                let threadList = this.props.threads.filter(t => t.id === this.props.match.params.threadId);
                
                if(threadList.length > 0){
                    thread = threadList[0];

                    let self = this;
                    this.setState({currentThread: this.props.match.params.threadId}, () => {
                        setTimeout(function(){
                            if(self.props.socket){
                                self.loadMoreInitial();
                            }
                        }, 1000);
                    });
                        
                }
                
                
            }
            
           
        }else if(this.props.match.params.profileId){
        }
    }
    
    componentDidMount(){
        let self = this;
        let newLog = {
            date: new Date(),
            duration: 0,
            type: 'Messages',
            subject: '',
            chapter: '',
            activity: '',
            score: 'NA',
            courseUserId: this.props.courseUser[0].id,
            userId: this.props.user.user.id
        }

        this.props.createLog(newLog, this.props.user.id);
        this.props.initChat(this.props.user.user.Profile.id, this.props.user.id);

        

        this.determineThread();
    }
    
    
    loadMoreInitial = () => {
        
        if(this.props.socket && this.state.currentThread){
            let thread = {};
            let threadList = this.props.threads.filter(t => t.id === this.props.match.params.threadId);
                
            if(threadList.length > 0){
                thread = threadList[0];
            }
            this.setState({loading: true}, () => {
                
                let command = jwt.sign({
                        command: {
                            type: 'LOAD_MORE_MESSAGES',
                            profileId: this.props.user.user.Profile.id,
                            skip: thread.Messages ? thread.Messages.length : 0,
                            threadId: thread.id,
                            initial: true,
                            token: this.props.user.id
                        }}, '#&r7%+UbWU8Hc');
                this.props.socket.send(command)

            })
            
                    
        }
    }

    componentWillUnmount(){
        let {currentLog} = this.props;
        currentLog.end = new Date();
        this.props.updateLog(currentLog, this.props.user.id);
    }
    
    componentDidUpdate = (props) => {
        this.determineThread();
        
        let {currentThread} = this.state;
        
        if(props.match.params.threadId !== this.state.currentThread){
            this.setState({currentThread: props.match.params.threadId});
            
        }
       
        if(currentThread){
            let oldThread = props.threads.filter(t => t.id == currentThread);
            let newThread = this.props.threads.filter(t => t.id === currentThread);
            
            if(oldThread.length > 0 && newThread.length > 0){
                if(oldThread[0].Messages && newThread[0].Messages){
                    if(oldThread[0].Messages.length !== newThread[0].Messages.length){
                        
                        this.setState({loading: false});
                    }    
                
                }
            }
            
        }
        
        
        if(props.online !== this.props.online){
            // User has changed status
            this.setState({changingStatus: true}, () => {
                let self = this;
                setTimeout(function(){
                    self.setState({changingStatus: false});
                }, 2000);
            })
        }
    }
    
    createThread = (profile) => {
        let thread = {
            users: [this.props.user.user.Profile.id, profile.id],
            createdAt: new Date(),
            status: 1,
            lastActivity: new Date()
        }

        let command = jwt.sign({
                        command: {
                          type: 'CREATE_THREAD',
                          thread: thread,
                            token: this.props.user.id
                        }}, '#&r7%+UbWU8Hc');
        this.props.socket.send(command)
      
        //this.props.createThread(thread, this.props.user.id);
    }
    
    readFile = (file) => {
        var fr = new FileReader();
        fr.onload = function () {
            $('[data-file="'+ file.name +'"]').attr('src', fr.result);
        }
        fr.readAsDataURL(file);

    }
    
    searchUsers = () => {
        
    }
    
    
    renderMainComponent = () => {
        let thread = {};
        
        let {settings} = this.props;
        
        
        if(this.props.match.path.indexOf('chat/admin') > -1 && this.props.user.user.Profile.role === 'admin'){
            // Render Admin Routes
            
            if(this.props.match.params.view === 'tickets'){
                return (
                    <AdminTicketView adminMode={true} course={this.props.course} {...this.props} thread={thread} currentThread={this.state.currentThread} />    
                )
                
            }else if(this.props.match.params.view === 'instructors'){
                return (
                    <AdminInstructorView {...this.props} thread={thread} currentThread={this.state.currentThread} />
                )
            }else  if(this.props.match.params.view === 'announcements'){
                return (
                    <AdminAnnouncementsView {...this.props} thread={thread} currentThread={this.state.currentThread} socket={this.props.socket} />
                )
            }else if(this.props.match.params.view === 'attachments'){
                return (
                    <AdminAttachmentsView {...this.props} thread={thread} currentThread={this.state.currentThread} />
                )
            }else if(this.props.match.params.view === 'flagged-comments'){
                return (
                    <AdminFlaggedCommentsView {...this.props} thread={thread} currentThread={this.state.currentThread} socket={this.props.socket} />
                )
            }else if(this.props.match.params.view === 'settings'){
                return (
                    <AdminChatSettingsView {...this.props} thread={thread} currentThread={this.state.currentThread}  />
                )
            }
        }else if(this.props.user.user.Profile.role === 'student'){
            if(this.props.match.params.threadId === 'tickets'){
                return (
                    <TicketView chatSubject={this.props.chatSubject} getChatLectures={this.props.getChatLectures} course={this.props.course} {...this.props} thread={thread} currentThread={this.state.currentThread} />
                )
            }
        }else if(this.props.user.user.Profile.role === 'instructor'){
            if(this.props.match.params.threadId === 'tickets'){
                return (
                    <AdminTicketView adminMode={false} course={this.props.course} {...this.props} thread={thread} currentThread={this.state.currentThread} />    
                )
            }
        }
        
        if(this.props.match.params.threadId && this.props.match.params.threadId !== "tickets"){
            let threadList = this.props.threads.filter(t => t.id === this.props.match.params.threadId);
            
            if(threadList.length > 0){
                thread = threadList[0];
            }
            
            if(this.state.currentThread){
                let disableStudentChat = settings.filter(s => s.name === "disableStudentChat")[0].value;
                let disableCourseChat = settings.filter(s => s.name === "disableCourseChat")[0].value;

                if(this.props.user.user.Profile.role === 'student' && !thread.subjectId && (disableStudentChat === true || disableStudentChat === "true")){
                    return (
                        <div><h1 className="disabled-chat">Student chat has been disabled.</h1></div>
                    )
                }else if(thread.subjectId && (disableCourseChat === true || disableCourseChat === "true")){
                    return (
                        <div><h1 className="disabled-chat">Course Chat has been disabled.</h1></div>
                    )
                }
                
                return (
                    <ThreadView course={this.props.course} {...this.props} thread={thread} currentThread={this.state.currentThread} />
                )
            }
        }
        
        
        
        
    }
    
    render (){
        let thread = {};
        if(this.props.match.params.threadId){
            let threadList = this.props.threads.filter(t => t.id === this.props.match.params.threadId);
            
            if(threadList.length > 0){
                thread = threadList[0];
            }
        }
        
        const linkOptions = {
            target: '_blank'
        }
        
        let {settings} = this.props;
        let disableChat = false;
        if(settings){
            if (settings.filter(s => s.name === "disableChat").length > 0) {
                disableChat = settings.filter(s => s.name === "disableChat")[0].value;

            }
            
        }
        
        return (
            <div className={`${this.state.changingStatus ? 'modal-open' : ''}`}>
             <div
                className={`content-wrapper ${this.state.sidebarOpened ? 'chat-sidebar-active' : ''}`}
                id="content-container"
                style={{minHeight: 627, height: "calc(100vh - 51px)"}}
            >
            
            
            {(disableChat == "true" || disableChat == true) && this.props.user.user.Profile.role !== 'admin' ?
                <div><h1 className="disabled-chat">Chat has been globally disabled.</h1></div>
            :
            
                <section className="content chat-area">
                
                    {this.props.user.user.Profile.role === 'student' &&
                        <ChatSidebar 
                            threads={this.props.threads} 
                            socket={this.props.socket} 
                            users={this.props.users} 
                            online={this.props.online} 
                            user={this.props.user}
                            courseUser={this.props.courseUser}
                            createThread={this.createThread}
                            settings={this.props.settings}
                            course={this.props.course}
                            messengerSearch={(term, token) => this.props.messengerSearch(term, token)}
                            />
                    }
                    
                    {this.props.user.user.Profile.role === 'instructor' &&
                        <InstructorChatSidebar allCourseUsers={this.props.allCourseUsers} course={this.props.course} threads={this.props.threads} socket={this.props.socket} users={this.props.users} online={this.props.online} user={this.props.user} courses={this.props.courses} settings={this.props.settings} setSidebarTab={this.props.setSidebarTab} sidebarTab={this.props.sidebarTab} />
                    }
                    
                    {this.props.user.user.Profile.role === 'admin' &&
                        <AdminChatSidebar course={this.props.course} threads={this.props.threads} socket={this.props.socket} users={this.props.users} online={this.props.online} user={this.props.user} courses={this.props.courses} view={this.props.match} />
                    }
                    
                    
                    {this.renderMainComponent()}
                    
                
                </section>
            }
        </div>
        
        
    
    
    
    <div className={`modal fade ${this.state.changingStatus ? 'in' : 'in'}`} style={{display: (this.state.changingStatus) ? 'block' : 'none', paddingTop: '200px'}}id="ChatToggleModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div className="modal-dialog modal-sm" role="document">
            <div className="modal-content">
    
                <div className="modal-body">
                    <div className="text-center text-white sp-top-bottom50">
                        <h3 id="ChatStatus">
                        <i className={`zmdi zmdi-comments ${this.props.online ? 'text-success' : 'text-danger'}`}></i> Chat is now {this.props.online ? 'on' : 'off'}
                        </h3>
                    </div>
                </div>
    
            </div>
        </div>
    </div>
    </div>
        )
    }
}

export default Chat;


// WEBPACK FOOTER //
// ./src/components/Chat/Chat.js